import { Typography } from "antd";

const { Text } = Typography;

interface CostInfoLineProps {
  text: string;
}

export default function CostInfoLine({ text }: CostInfoLineProps) {
  return (
    <Text
      type="secondary"
      style={{
        fontSize: 11,
        marginTop: 4,
        fontFamily: "monospace",
        whiteSpace: "pre-line",
        lineHeight: 1.6,
      }}
    >
      {text}
    </Text>
  );
}
